const initHeadingsSliderWidget = () => {
    const flickitySlidersArray = initCarousel("[data-headings-slider] [data-slider]", cellAlign.center, true, false, true, true, false);
    //flickitySlidersArray && flickitySlidersArray.forEach(flickitySlider => {
    //})
};
